import { Injectable } from '@angular/core';
import { map, catchError, timeout,retry } from 'rxjs/operators';
import { HttpResponse, HttpHeaders, HttpErrorResponse, HttpParams, HttpClient } from '@angular/common/http';




import { throwError } from 'rxjs';



import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class HomeService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  getSlider(sliderUrl) {
    return this.httpClientService.get(sliderUrl)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }

  triggerActiveFans(data) {

    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    // headers = headers.append('iv-user', sessionStorage.getItem('iv-user'));

    let url;
    url = this.utilityService.getEnvConfig().triggerActiveFans;

    return this.httpClientService.post(url, data, headers).pipe( 
      timeout(300000),
      retry(3),
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          //this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      }),
      catchError(this.handleError));

  }

  createPageLoadProperties() {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_HOME;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_HOME;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = ANALYTICS_CONSTANTS.BC_LANGUAGE_EN;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_HOME.replace('BC ', '').replace(' Pg', '');
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}

